import request from "../request";

export const getCustomerOrderDetail = (orderNo) => {
  return request.get(`/wechat/order/detail/${orderNo}`);
};

export const chooseDeliveryApi = (data) => {
  return request.post(`/wechat/order/choose-delivery`, data);
};

// 顾客端填写发票
export const setBill = (data) => {
  return request.post(`/wechat/order/apply-bill`, data);
};

// 顾客端确认收货
export const receipt = (orderId) => {
  return request.post(`/wechat/order/receipt`, { orderId });
};

// 获取面对面提货二维码
export const getQrCode = (orderId) => {
  return request.get(`/wechat/order/face-to-face-qrcode/${orderId}`);
};

// 获取物流信息
export const getWeChatRouteInfo = (orderId) => {
  return request.get(`/wechat/order/route-info/${orderId}`);
};
